<template>
  <div class="text-center p-8">
    <p class="text-base">
      Pembayaran Berhasil
    </p>
    <div class="flex justify-center mt-6">
      <g-button
        :label="'Donasi Lagi'"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { GButton } from '../components';

export default {
  components: {
    GButton,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const codeParam = computed(() => store.state.codeParam);
    const nameParam = computed(() => store.state.nameParam);
    const vidParam = computed(() => store.state.vidParam);

    function handleClick() {
      router.push({
        name: 'HOME',
        query: {
          vid: vidParam.value,
          code: codeParam.value,
          name: nameParam.value,
        },
      });
    }

    return {
      handleClick,
    };
  },
};
</script>
